var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { paymentFormSchema } from "./paymentFormSchema";
import { CardNumberField, CardExpirationMonth, CardExpirationYear, CardSecurityCode, CardHolderNameField, } from "./fields";
import "../ui.css";
import "./paymentForm.css";
import { Form } from 'radix-ui';
import { RadixButton } from "../primitives/RadixButton";
import { RadixCheckbox } from "../primitives/RadixCheckbox";
import { Card } from "../card";
import { OrderSummary } from "../orderSummary";
import * as LabelPrimitive from "@radix-ui/react-label";
export var PaymentForm = function (_a) {
    var onSubmit = _a.onSubmit, id = _a.id, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.orderSummaryNcaFeeDescription, orderSummaryNcaFeeDescription = _c === void 0 ? null : _c, paymentFields = _a.paymentFields, _d = _a.validatePaymentFields, validatePaymentFields = _d === void 0 ? true : _d, savePaymentOption = _a.savePaymentOption, _e = _a.fieldAttributes, fieldAttributes = _e === void 0 ? {} : _e, children = _a.children;
    var methods = useForm({
        resolver: zodResolver(paymentFormSchema),
        mode: "onChange",
        defaultValues: {
            cardholderName: "",
            cardNumber: "",
            expirationMonth: "",
            expirationYear: "",
            securityCode: "",
        },
    });
    var handleSubmit = methods.handleSubmit, isValid = methods.formState.isValid;
    var isDisabled = Boolean(disabled);
    var isPaymentFormValid = !validatePaymentFields || isValid;
    var savePaymentOptionDisabled = savePaymentOption ? savePaymentOption.disabled : false;
    var saveOptionDisabled = Boolean(isDisabled || !isPaymentFormValid || savePaymentOptionDisabled);
    var submitDisabled = isDisabled || !isPaymentFormValid;
    var handleFormSubmit = function (event) {
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        if (validatePaymentFields) {
            void handleSubmit(onSubmit)(event);
            return;
        }
        event.preventDefault();
        onSubmit(methods.getValues());
    };
    var withDisabled = function (attributes) { return (__assign(__assign({}, attributes), { disabled: isDisabled || (attributes === null || attributes === void 0 ? void 0 : attributes.disabled) })); };
    return (React.createElement(FormProvider, __assign({}, methods),
        React.createElement(Form.Root, { id: id, onSubmit: handleFormSubmit, className: "radix-form radix-payment-form", noValidate: true },
            React.createElement(Card, null,
                children,
                React.createElement(LabelPrimitive.Root, null, "Enter Payment Details"), paymentFields !== null && paymentFields !== void 0 ? paymentFields : (React.createElement(React.Fragment, null,
                fieldAttributes.cardholderName ? (React.createElement(CardHolderNameField, __assign({}, withDisabled(fieldAttributes.cardholderName)))) : null,
                React.createElement(CardNumberField, __assign({}, withDisabled(fieldAttributes.cardNumber))),
                React.createElement("div", { className: "radix-payment-expiration-row" },
                    React.createElement(CardExpirationMonth, __assign({}, withDisabled(fieldAttributes.expirationMonth))),
                    React.createElement(CardExpirationYear, __assign({}, withDisabled(fieldAttributes.expirationYear)))),
                React.createElement(CardSecurityCode, __assign({}, withDisabled(fieldAttributes.securityCode))))),
                savePaymentOption ? (React.createElement(RadixCheckbox, { checked: savePaymentOption.checked, onCheckedChange: savePaymentOption.onCheckedChange, disabled: saveOptionDisabled, label: savePaymentOption.label, description: savePaymentOption.description, describedBy: savePaymentOption.describedBy })) : null,
                React.createElement(OrderSummary, { ncaFeeDescription: orderSummaryNcaFeeDescription }),
                React.createElement(RadixButton, { type: "submit", disabled: submitDisabled, className: "radix-submit-button mw-100" }, "Pay and Finalize Order")))));
};
